const resaleArticles = state => state.partners.resaleArticles;

const article = state => state.partners.article;

export default {
  resaleArticles,

  article,
};
